// global.SET_API_URL = 'http://localhost:5000/'

// global.SET_API_URL = 'https://server.lb.whdevs.com/'

global.SET_API_URL = 'http://98.90.41.32:5001/'

// global.SET_API_URL = 'http://192.168.10.3:5000/'

// global.SET_API_URL = 'http://192.168.10.2:5000/'

global.COMPANY_NAME = 'WORLD HOME DEVELOPMENT'

global.targetDate = new Date()
